import { createFileRoute } from '@tanstack/react-router';
import { BonusPaySlipLayoutRegistryPage } from './-components/BonusPaySlipLayoutRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/bonus-payslips/')({
  component: BonusPaySlipLayoutRegistryPage
});